import { render, staticRenderFns } from "./display-serial-product.vue?vue&type=template&id=d8bc599e&scoped=true"
import script from "./display-serial-product.vue?vue&type=script&lang=js"
export * from "./display-serial-product.vue?vue&type=script&lang=js"
import style0 from "./display-serial-product.vue?vue&type=style&index=0&id=d8bc599e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bc599e",
  null
  
)

export default component.exports